import GoogleOneTapSignIn from "components/auth/GoogleOneTapSignIn";
import Footer from "components/landing/Footer";
import Header from "components/landing/Header";
import SignUpNow from "components/landing/SignUpNow";
import AboutUs from "components/landing/sections/AboutUs";
import AlternativeFeatureCards from "components/landing/sections/AlternativeFeatureCards";
import PlatformAssetTypeSection from "components/landing/sections/PlatformAssetTypeSection";
import PlatformFeaturesSection from "components/landing/sections/PlatformFeaturesSection";
import PlatformMetricsSection from "components/landing/sections/PlatformMetricsSection";
import PlatformPricesSection from "components/landing/sections/PlatformPricesSection";
import Quote from "components/landing/sections/Quote";
import TestimonialsSection from "components/landing/sections/TestimonialsSection";
import TwoPassRender from "components/shared/TwoPassRender";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { useFlagValue } from "lib/flagging/FeatureFlags";
import { useIntl } from "react-intl";

export default function Landing() {
  const intl = useIntl();
  const amplitude = useAmplitude();
  const displayVideo = useFlagValue("marketing/landing/displayVideoOnLanding");

  return (
    <main className="mx-auto overflow-x-hidden scroll-smooth bg-white">
      <GoogleOneTapSignIn />
      <Header />
      <PlatformMetricsSection />
      <PlatformAssetTypeSection />
      <AlternativeFeatureCards />
      <PlatformFeaturesSection />
      <TwoPassRender>{() => <PlatformPricesSection />}</TwoPassRender>
      <TestimonialsSection />
      <AboutUs />
      {intl.locale !== "pt-BR" && <Quote />}
      <SignUpNow
        onClick={() => {
          amplitude.logEvent("Clicked on Sign Up on the landing page", {
            content: displayVideo ? "video" : "gif",
            location: "footer",
          });
        }}
      />
      <Footer />
    </main>
  );
}
